export const formatStatValue = (value: number | null, suffix = '') =>
  typeof value === 'number' && Number.isFinite(value)
    ? `${value.toFixed(2)}${suffix}`
    : 'n/a';
